"use client";

import { Link } from "@/i18n/navigation";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faTwitter,
  // faLinkedin,
  // faYoutube,
  faAppStore,
  faGooglePlay,
} from "@fortawesome/free-brands-svg-icons";
import { useTranslations } from "next-intl";

const FooterSection = () => {
  const t = useTranslations("HomePage.footer");
  return (
    <footer className="border-t border-gray-200 py-20">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4">
            <Link href="/" className="text-xl font-bold" scroll={false}>
              {t("osoul")}
            </Link>
          </div>
          <nav className="mb-4">
            <ul className="flex gap-4">
              <li>
                <Link href="/about">{t("aboutUs")}</Link>
              </li>
              <li>
                <Link href="/contact">{t("contactUs")}</Link>
              </li>
              <li>
                <Link href="/faq">{t("faq")}</Link>
              </li>
              <li>
                <Link href="/terms">{t("terms")}</Link>
              </li>
              <li>
                <Link href="/privacy">{t("privacy")}</Link>
              </li>
            </ul>
          </nav>
          <div className="flex gap-4 mb-4">
            <a
              href="https://apps.apple.com/qa/app/osoul/id6747296555?l=ar"
              aria-label="Facebook"
              className="hover:text-primary-600"
            >
              <FontAwesomeIcon icon={faAppStore} className="h-6 w-6" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.vesco.osoul"
              aria-label="Google Play"
              className="hover:text-primary-600"
            >
              <FontAwesomeIcon icon={faGooglePlay} className="h-6 w-6" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61576976021747"
              aria-label="Facebook"
              className="hover:text-primary-600"
            >
              <FontAwesomeIcon icon={faFacebook} className="h-6 w-6" />
            </a>
            <a
              href="https://www.instagram.com/osoul.qa/"
              aria-label="Instagram"
              className="hover:text-primary-600"
            >
              <FontAwesomeIcon icon={faInstagram} className="h-6 w-6" />
            </a>
            <a href="#" aria-label="Twitter" className="hover:text-primary-600">
              <FontAwesomeIcon icon={faTwitter} className="h-6 w-6" />
            </a>
            {/* <a
              href="#"
              aria-label="Linkedin"
              className="hover:text-primary-600"
            >
              <FontAwesomeIcon icon={faLinkedin} className="h-6 w-6" />
            </a> */}
            {/* <a href="#" aria-label="Youtube" className="hover:text-primary-600">
              <FontAwesomeIcon icon={faYoutube} className="h-6 w-6" />
            </a> */}
          </div>
        </div>
        <div className="mt-8 text-center text-sm text-gray-500 flex justify-center gap-4">
          <span>{t("copyright")}</span>
          <Link href="/privacy">{t("privacyPolicy")}</Link>
          <Link href="/terms">{t("termsOfService")}</Link>
          <Link href="/cookies">{t("cookiePolicy")}</Link>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
